import { Link } from "@tanstack/react-router";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useLogout } from "@/hooks/use-logout";
import { SupportForm } from "@/modules/support/support-forrm";
import { formModal } from "../FormModal";

export const ProfileDropdownSettingsButton = () => {
	const { t } = useTranslation();

	return (
		<DropdownMenuItem asChild>
			<Link className="cursor-pointer" to={"/dashboard/settings"}>
				{t(($) => $.common.components.profileDropdown.items.settings)}
			</Link>
		</DropdownMenuItem>
	);
};

export const ProfileDropdownHelpButton = () => {
	const { t } = useTranslation();

	const onClick = useCallback(() => {
		formModal.open({
			title: t(($) => $.modules.support.title),
			description: t(($) => $.modules.support.description),
			form: <SupportForm onSuccess={() => formModal.close()} />,
		});
	}, [t]);

	return (
		<DropdownMenuItem className="cursor-pointer" onClick={onClick}>
			{t(($) => $.common.components.profileDropdown.items.help)}
		</DropdownMenuItem>
	);
};

export const ProfileDropdownLogoutButton = () => {
	const { t } = useTranslation();
	const { mutate: logout } = useLogout();

	return (
		<DropdownMenuItem className="cursor-pointer" onClick={() => logout()}>
			{t(($) => $.common.components.profileDropdown.items.logout)}
		</DropdownMenuItem>
	);
};
